import React from 'react';
import './style.scss';

const UserCard = ({title,titleDescription,day,date,color}) => {
  return (
    <div className="request-name-container" style={{color:`var(${color})`}}>
    <div className="name-member">
      <button style={{color:`var(${color})`}}>{title}</button>
      <p>{titleDescription}</p>
    </div>
    <div className="date-details">
      <p>{day}</p>
      <p>{date}</p>
    </div>
  </div>
  )
}

export default UserCard